(function () {
    'use strict';

    angular
        .module('app')
        .controller('CreateEditSpaceController', CreateEditSpaceController);

    CreateEditSpaceController.$inject = ['$http', '$rootScope', '$stateParams', '$state', '$filter', '$scope', 'dateParser', 'dialog', 'countries', 'emojiReplacer', 'cache', 'eventTracker'];

    function CreateEditSpaceController($http, $rootScope, $stateParams, $state, $filter, $scope, dateParser, dialog, countries, emojiReplacer, cache, eventTracker) {
        var phone;
        $rootScope.header_inverted = false;
        $rootScope.on_dashboard = false;
        var vm = this;
        vm.$onInit = init;
        vm.save = save;
        vm.softDelete = softDelete;
        vm.close = close;
        vm.countries = countries.filter(function (country) {
            return country.eligible_for_host != null;
        });
        vm.showPreview = showPreview;
        vm.hostSeatsInfo = hostSeatsInfo;
        vm.hostPhotoInfo = hostPhotoInfo;
        vm.hostIntroductionInfo = hostIntroductionInfo;
        vm.hostAboutYouInfo = hostAboutYouInfo;
        vm.hostExpectationsInfo = hostExpectationsInfo;
        vm.selectGenre = selectGenre;
        vm.addressSectionIsValid = addressSectionIsValid;
        vm.setCountryRegions = setCountryRegions;
        vm.selectSpaceType = selectSpaceType;
        vm.updateCountryRegions = updateCountryRegions;
        vm.canDelete = true;

        $scope.$on("$locationChangeStart", function (event) {
            if (!vm.waiting_for_verification && vm.spaceForm && vm.spaceForm.$dirty) {
                event.preventDefault();
                close();
            }
        });

        function getUser() { //Gets information about the currently logged-in user
            $http.get('api/private/users/')
                .then(function (response) {
                    vm.user = response.data;
                    $rootScope.user_stripe_connection = response.data.user_stripe_connected_account_token;
                    setTimeout(function () {
                        if (vm.user.user_phone_country_code) {
                            phone.setCountry(vm.user.user_phone_country_code);
                        }
                        phone.setNumber(vm.user.user_phone);
                    }, 10);
                })
        }

        function hostSeatsInfo() {
            dialog.info('host-seats-info');
        }

        function hostPhotoInfo() {
            dialog.info('host-photo-info');
        }

        function hostIntroductionInfo() {
            dialog.info('host-introduction-info');
        }

        function hostAboutYouInfo() {
            dialog.info('host-about-you-info');
        }

        function hostExpectationsInfo() {
            dialog.info('host-expectations-info');
        }

        function showPreview() {
            var state = 'space_preview';
            var params = {};
            params['space_slug'] = vm.slug;

            save().then(function (response) {
                $state.go(state, params);
            });
        }

        function close() {
            if (!vm.waiting_for_verification && vm.spaceForm && vm.spaceForm.$dirty) {
                if (vm.space.space_published) {
                    dialog.prompt('unsaved-changes-prompt', function (response) {
                        if (response.confirm) {
                            returnToPreviousPage();
                        }
                        if (response.alternative) {
                            vm.spaceForm.$setSubmitted();
                            save().then(function () {
                                returnToPreviousPage();
                            });
                        }
                    }, true);
                } else {
                    dialog.prompt('unsaved-changes-draft-prompt', function (response) {
                        if (response.confirm) {
                            returnToPreviousPage();
                        }
                        if (response.alternative) {
                            save(true).then(function () {
                                returnToPreviousPage();
                            });
                        }
                    }, true);
                }
            } else {
                returnToPreviousPage();
            }
        }

        function returnToPreviousPage() {
            if ($stateParams.return_page && !$stateParams.return_params) {
                return $state.go($stateParams.return_page);
            } else if ($stateParams.return_page && $stateParams.return_params) {
                return $state.go($stateParams.return_page, $stateParams.return_params);
            } else {
                return $state.go('member', { tab: 'profiles' });
            }
        }

        function init() {
            vm.loaded = false;
            var unregister_uploaded_image_exists_event = $rootScope.$on('uploaded_image_exists', function (event, args) {
                if (args.type === 'spaces' && args.image_number == 1) {
                    vm.header_image_set = args.image_exists;
                }
            });
            $scope.$on('$destroy', unregister_uploaded_image_exists_event);

            var unregister_uploaded_image_deleted_event = $rootScope.$on('uploaded_image_deleted', function (event, args) {
                $scope.$applyAsync(function () {
                    if (args.type === 'spaces' && args.image_number == 1) {
                        vm.header_image_set = false;
                    }
                });
            });
            $scope.$on('$destroy', unregister_uploaded_image_deleted_event);

            var unregister_new_image_upload_event = $rootScope.$on('new_image_upload', function (event, args) {
                if (vm.photo_counter == args.image_number) {
                    vm.photo_counter += 1;
                }
            });

            $scope.$on('$destroy', unregister_new_image_upload_event);

            var unregister_uploaded_image_temp = $rootScope.$on('uploaded_image_temp', function (event, args) {
                vm.upload_image_slug = args.temp_slug;
            });
            $scope.$on('$destroy', unregister_uploaded_image_temp);

            vm.slug = $stateParams.space_slug;
            vm.space = {};
            vm.space.selected_genres = [];
            vm.space.space_charges_for_booking = 1;
            vm.photo_counter = 1;

            getGenres()

            getUser();
            getCountryRegions();
            if (!vm.slug) {
                vm.space.space_type = 'private_home';
                vm.space.space_country = 'DK';
                vm.slug = "new";
                vm.loaded = true;
            } else {
                getContent();
                setCanDelete();
            }

            setTimeout(function () {
                var input = document.querySelector("#phone");
                phone = window.intlTelInput(input, {
                    utilsScript: "app/assets/js/utils.js",
                    preferredCountries: ["dk", "gb", "se"],
                    defaultCountry: "dk",
                    formatOnDisplay: false,
                    customContainer: "international-phone-input"
                });
                input.addEventListener("countrychange", function (e) {
                    vm.spaceForm.$setDirty();
                    $scope.$apply();
                });
            }, 0);
        }

        function selectedGenres() {
            var selectedGenres = [];
            vm.genres.forEach(function (genre) {
                if (genre.selected) {
                    selectedGenres.push(genre)
                }
            });
            return selectedGenres;
        }

        function selectGenre(genre) {
            if (!genre.selected && selectedGenres().length == 5) {
                return;
            }
            genre.selected = !genre.selected;
            vm.spaceForm.$setDirty();
        }

        function getGenres() {
            if (cache.exists('genres')) {
                vm.genres = cache.load('genres');
                return Promise.resolve();
            } else {
                return $http.get('api/genres/')
                    .then(function (response) {
                        vm.genres = response.data;
                        cache.save('genres', vm.genres);
                    });
            }
        }

        function getContent() {
            return $http.get('api/spaces/' + vm.slug + '/')
                .then(function (response) {
                    if(!response.data.user_is_space_admin){
                        return $state.go('frontpage');
                    }
                    vm.space = response.data;

                    vm.images = [];
                    for (var image in vm.space.image_exists) {
                        if (vm.space.image_exists[image]) {
                            vm.images.push(image);
                        }
                    }
                    vm.image_numbers = vm.images.map(Number);
                    vm.photo_counter = vm.image_numbers.length > 0 ? vm.image_numbers.reduce(function (a, b) { return Math.max(a, b); }) + 1 : 1;

                    if (!vm.space.space_published && !vm.space.space_is_draft) {
                        vm.waiting_for_verification = true;
                    }
                    vm.space.space_hosting_fee = vm.space.space_hosting_fee ? vm.space.space_hosting_fee.toString() : '0';
                    setCountryRegions();
                    makeSpaceShadow();
                    vm.genres.forEach(function (genre) {
                        vm.space.selected_genres.forEach(function (selected_genre) {
                            if (genre.filter_value_id == selected_genre.filter_value_id) {
                                genre.selected = true;
                            }
                        })
                    })
                    vm.loaded = true;
                    $scope.$applyAsync();
                });
        }

        function getCountryRegions() {
            $http.get('api/country_regions/')
                .then(function (response) {
                    vm.allCountryRegions = response.data;
                    if (vm.space.space_country) {
                        setCountryRegions();
                    }
                })
        }

        function setCountryRegions() {
            vm.countryRegions = vm.allCountryRegions.filter(function (countryRegion) {
                return countryRegion.country_iso_code == vm.space.space_country;
            });
        }

        function updateCountryRegions() {
            vm.space.space_country_region_id = null;
            vm.countryRegions = vm.allCountryRegions.filter(function (countryRegion) {
                return countryRegion.country_iso_code == vm.space.space_country;
            });
        }

        function setCanDelete() {
            $http.get('api/spaceconcerts/' + vm.slug + '/')
                .then(function (response) {
                    Object.values(response.data).forEach(function (concert) {
                        if (moment(concert.concert_start_time).isAfter(moment())) {
                            vm.canDelete = false;
                        }
                    })

                });
        }

        function formIsValid() {
            return vm.spaceForm.$valid && vm.space.primary_image && vm.space.space_description_short.length >= 80 && vm.space.space_description_short.length <= 165 && vm.space.space_description_long.length >= 100 && vm.space.space_description_long.length <= 600 && vm.space.space_description_expectations.length >= 100 && vm.space.space_description_expectations.length <= 600;
        }

        function addressSectionIsValid() {
            return vm.space.space_name && vm.space.space_address && vm.space.space_zip && vm.space.space_city && vm.user.user_phone;
        }

        function updateUser() { //Updates data about user based on inputted data
            if (vm.user.user_phone !== "") {
                var data = {
                    space_description_short: emojiReplacer.replaceEmojis(vm.space.space_description_short),
                    space_description_long: emojiReplacer.replaceEmojis(vm.space.space_description_long),
                    space_description_expectations: emojiReplacer.replaceEmojis(vm.space.space_description_expectations),
                    user_phone: phone.getNumber(),
                    user_phone_country_code: phone.getSelectedCountryData().iso2.toUpperCase()
                };

                $http.patch('api/users/' + vm.user.user_slug + '/', data)
                    .then(function (response) { //Sets cookies corresponding to the new data
                        console.log('api/users/' + vm.user.user_slug + '/ response', response);
                    });
            }

        }

        function save(is_draft) {
            vm.save_data = 1;
            vm.phone_country_set = phone.getSelectedCountryData().iso2;
            if (!is_draft && !formIsValid()) {
                setTimeout(function () {
                    document.querySelector('.scroll-child').scrollTop = document.querySelector('.scroll-child').scrollHeight;
                }, 0);
                return false;
            } else if (is_draft && !vm.space.space_name) {
                vm.showSpaceNameRequired = true;
                return;
            } else if (is_draft && !addressSectionIsValid()) {
                vm.showAddressSectionRequired = true;
                return;
            }
            if (!is_draft) {
                vm.hideDraftButton = true;
            }
            vm.showSpaceNameRequired = false;

            updateUser();

            vm.save_progress = 'saving';

            var data = {
                space_name: vm.space.space_name,
                space_type: vm.space.space_type,
                space_published: vm.space.space_published,
                space_description_short: emojiReplacer.replaceEmojis(vm.space.space_description_short),
                space_description_long: emojiReplacer.replaceEmojis(vm.space.space_description_long),
                space_description_expectations: emojiReplacer.replaceEmojis(vm.space.space_description_expectations),
                space_address: vm.space.space_address,
                space_zip: vm.space.space_zip,
                space_city: vm.space.space_city,
                space_country: vm.space.space_country,
                space_country_region_id: vm.space.space_country_region_id,
                space_seat_no: vm.space.space_seat_no,
                space_link: vm.space.space_link,
                space_hosting_fee: vm.space.space_hosting_fee,
                space_facebook: vm.space.space_facebook,
                space_youtube: vm.space.space_youtube,
                space_instagram: vm.space.space_instagram,
                space_other_social_media_links: vm.space.space_other_social_media_links,
                upload_image_slug: vm.upload_image_slug,
                genres: selectedGenres(),
                space_is_draft: is_draft == undefined ? 0 : 1,
                primary_image: vm.space.primary_image,
                secondary_images: vm.space.secondary_images
            };

            if (vm.slug === "new") {
                return $http.post('api/spaces/', data)
                    .then(function (response) {
                        if (cache.exists('user_bands')) {
                            cache.clear('user_bands');
                        }
                        if (!response.data !== undefined && response.data.space_slug !== undefined) {
                            if (is_draft) {
                                $state.go('edit_space', { space_slug: response.data.space_slug }, { location: 'replace' }).then(function () {
                                    $state.go('member', { tab: 'profiles' });
                                });
                            } else {
                                eventTracker.hostSignup({
                                    'country': data.space_country,
                                    'region': vm.allCountryRegions[vm.space.space_country_region_id - 1].country_region_name,
                                    'spaceType': data.space_type,
                                    'capacity': data.space_seat_no,
                                    'genre': data.genres[0].filter_value_name
                                });
                                $state.go('edit_space', { space_slug: response.data.space_slug })
                            }
                            vm.save_progress = 'success';
                        } else if (response.data === 'Space with name already exists') {
                            vm.save_progress = 'error';
                            alert('A space with the name ' + vm.space.space_name + ' already exists. Please pick a different name and try again.');
                        }
                    });
            } else {
                return $http.patch('api/spaces/' + vm.slug + '/', data)
                    .then(function (response) {
                        if (cache.exists('user_bands')) {
                            cache.clear('user_bands');
                        }
                        eventTracker.hostSignup({
                            'country': data.space_country,
                            'region': vm.allCountryRegions[vm.space.space_country_region_id - 1].country_region_name,
                            'spaceType': data.space_type,
                            'capacity': data.space_seat_no,
                            'genre': data.genres && data.genres.length > 0 ? data.genres[0].filter_value_name : ''
                        });
                        vm.save_progress = 'success';
                        vm.spaceForm.$setPristine();
                        if (!is_draft) {
                            vm.spaceForm.$setSubmitted();
                        }
                        if (!is_draft && !vm.space.space_published) {
                            vm.waiting_for_verification = true;
                        }
                        vm.save_progress = 'success';
                        makeSpaceShadow();
                        returnToPreviousPage();
                    });
            }
        }

        function selectSpaceType(spaceType) {
            vm.space.space_type = spaceType;
        }

        function softDelete() {
            dialog.prompt('delete-draft-prompt', function (response) {
                if (response.confirm) {
                    $http.delete('api/spaces/' + vm.slug + '/')
                        .then(function () {
                            if (cache.exists('user_bands')) {
                                cache.clear('user_bands');
                            }
                            returnToPreviousPage();
                        })
                }
            });
        }

        function makeSpaceShadow() {
            vm.space_shadow = angular.copy(vm.space);
        }
    }
})();
